import { Page } from '@/shared/api/pagination';
import type { Attribute, AttributeCreate } from '@/entities/srm/ci';
import type {
  AttributeSchemaTemplateDTO,
  CreateAttributeSchemaTemplateDTO,
} from '@/entities/srm/ci';
import type { NameDescriptionResponse } from '@/entities/srm/ci';
import type { KeyNameResponse, KeySchemaResponse } from '@/shared/api/response';
import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';
import type { CITypeAttribute } from '@/entities/srm/ci';
type OperatorSpec = { value_type: CITypeAttribute['value_type'] | string };
type OperatorSchema = Record<string, Record<string, OperatorSpec>>;
export class AttributesApi {
  static getAttributes(options?: AxiosRequestConfig) {
    return srmInstance.get<Page<Attribute>>(`/attribute`, {
      ...options,
    });
  }

  static createAttribute(
    payload: AttributeCreate,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<Attribute>(`/attribute`, payload, options);
  }

  static getValueTypes(options?: AxiosRequestConfig) {
    return srmInstance.get<KeyNameResponse[]>(
      `/attributes/value_types`,
      options,
    );
  }

  static getValueSchemas(options?: AxiosRequestConfig) {
    return srmInstance.get<KeySchemaResponse[]>(
      `/attributes/value_schemas`,
      options,
    );
  }

  static getValueTypesOperators(options?: AxiosRequestConfig) {
    return srmInstance.get<OperatorSchema>(`/value-type-operators`, options);
  }

  static getSystemFunctions(options?: AxiosRequestConfig) {
    return srmInstance.get<NameDescriptionResponse[]>(
      `/attributes/system_functions`,
      options,
    );
  }

  static getAttribute(id: string, options?: AxiosRequestConfig) {
    return srmInstance.get<Attribute>(`/attribute/${id}`, options);
  }

  static updateAttribute(
    id: string,
    payload: AttributeCreate,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<Attribute>(`/attribute/${id}`, payload, options);
  }

  static deleteAttribute(id: string, options?: AxiosRequestConfig) {
    return srmInstance.delete(`/attribute/${id}`, options);
  }

  static getTemplates(options?: AxiosRequestConfig) {
    return srmInstance.get<Page<AttributeSchemaTemplateDTO>>(
      '/templates',
      options,
    );
  }

  static createTemplate(
    payload: CreateAttributeSchemaTemplateDTO,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<AttributeSchemaTemplateDTO>(
      '/template',
      payload,
      options,
    );
  }

  static getTemplate(id: string, options?: AxiosRequestConfig) {
    return srmInstance.get<AttributeSchemaTemplateDTO>(
      `/template/${id}`,
      options,
    );
  }

  static updateTemplate(
    payload: AttributeSchemaTemplateDTO,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.put<AttributeSchemaTemplateDTO>(
      `/template/${payload?.id}`,
      payload,
      options,
    );
  }

  static deleteTemplate(id: string, options?: AxiosRequestConfig) {
    return srmInstance.delete<string>(`/template/${id}`, options);
  }
}